import { FC } from "react";
import styles from "./Breadcrumbs.module.scss";
import { IClassname } from "../../../types/classname";
import cl from "classnames";
import { P4 } from "../Typography";
import Link from "next/link";
import { SvgChevronLeft } from "../../icons/SvgChevronLeft";

interface IBreadcrumbItem {
  title: string;
  link?: string;
}
interface IBreadcrumbs extends IClassname {
  items: IBreadcrumbItem[];
}
export const Breadcrumbs: FC<IBreadcrumbs> = ({ items, className }) => {
  return (
    <nav className={cl(styles.bread, className)}>
      <ul className={styles.bread__list}>
        {items.map((i, index) => {
          const isLast = index === items.length - 1;
          return (
            <li
              key={i.title}
              className={cl(styles.bread__item, isLast && styles["bread__item--last"])}
            >
              {i.link ? <Link href={i.link}><P4>{i.title}</P4></Link> : <P4>{i.title}</P4>}
              {!isLast ? <SvgChevronLeft className={styles.bread__chevron} /> : null}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
